<script>
	export let name;
</script>

<main>
	<h1>S</h1>
</main>

<style>
	main {
		width: 100%;
		height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	h1 {
		font-size: 10rem;
		font-family: 'Bellico', monospace;
	}
</style>